import { useEffect, useMemo, useRef, useState } from 'react';
import { initialValues } from '../../modules/accounts/form/address/formData';
import { ISelect } from '../../../../shared/types/shared';
import { buildOrbitAddress } from './buildOrbitAddress';
import { ADDRESS_LETTER_OPTIONS } from './constants';
import { asyncGetOrbitCitiesFlat } from '../../../../services/orbit.service';
import { asyncGetOrbitAddressTypes } from './orbitAddressTypeParams';
import { getOrbitAddressValidationSchema } from './validationSchema';
import { useOrbitFormSection } from '../hooks/useOrbitFormSection';
import { OrbitAddressProps } from '../sectionProps';

export const useOrbitAddress = ({
    onChangeFormik,
    readOnly,
    seedValues,
}: OrbitAddressProps) => {
    const [cities, setCities] = useState<ISelect[]>([]);
    const [citiesError, setCitiesError] = useState<string>();
    const [types1, setTypes1] = useState<ISelect[]>([]);
    const [types1Error, setTypes1Error] = useState<string>();
    const types1Ref = useRef<ISelect[]>([]);
    types1Ref.current = types1;

    const validationSchema = useMemo(
        () =>
            getOrbitAddressValidationSchema(() =>
                types1Ref.current.map((type) => String(type.id))
            ),
        []
    );

    const { formik } = useOrbitFormSection({
        initialValues,
        validationSchema,
        onChangeFormik,
        readOnly,
        seedValues,
    });

    useEffect(() => {
        if (readOnly) return;

        const address = buildOrbitAddress(formik.values, cities, types1);
        formik.setFieldValue('address', address);
    }, [formik.values, cities, types1, readOnly]);

    useEffect(() => {
        if (!formik.touched.address && formik.submitCount === 0) return;
        formik.validateField('address');
    }, [
        formik.values.type1,
        formik.values.number1,
        formik.values.number2,
        formik.values.number3,
        formik.submitCount,
        formik.touched.address,
    ]);

    useEffect(() => {
        if (readOnly) return;

        asyncGetOrbitCitiesFlat().then(({ items, error }) => {
            setCities(items);
            setCitiesError(error);
        });

        asyncGetOrbitAddressTypes().then((items) => {
            setTypes1(items);
            setTypes1Error(
                items.length === 0
                    ? 'No se pudieron cargar los tipos de dirección.'
                    : undefined
            );
        });
    }, [readOnly]);

    return {
        formik,
        cities,
        citiesError,
        types1,
        types1Error,
        letters: ADDRESS_LETTER_OPTIONS,
    };
};
